import { useAuth } from '../../context/AuthContext'
import { useState } from 'react'

const Header = ({ onMenuToggle }) => {
  const { user, logout } = useAuth()

  const handleLogout = async (e) => {
    e.preventDefault()
    await logout()
    window.location.href = '/login'
  }

  return (
    <header className="admin-topbar">
      <div className="admin-topbar-left">
        <button
          type="button"
          className="admin-menu-toggle"
          onClick={onMenuToggle}
          aria-label="Open menu"
        >
          <i className="fa fa-bars" aria-hidden="true"></i>
        </button>
        <a href="/admin" className="admin-brand">
          <span className="brand-logo">
            <i className="fa fa-scissors" aria-hidden="true"></i>
          </span>
          <span>
            <div className="brand-name">HEET7 Studio</div>
            <div className="brand-sub">Admin Panel</div>
          </span>
        </a>
      </div>
      <div className="admin-user">
        <span className="user-chip">
          <span className="avatar">
            <i className="fa fa-user" aria-hidden="true"></i>
          </span>
          <span>{user?.username || 'Admin'}</span>
        </span>
        <form onSubmit={handleLogout} className="d-inline" title="Sign out">
          <button type="submit" className="logout-btn">
            <i className="fa fa-sign-out" aria-hidden="true"></i>
          </button>
        </form>
      </div>
    </header>
  )
}

export default Header
